export enum TitleVariant {
  Large = 'Large',
  Small = 'Small',
}
